<template>
    <div :class="{ 'blurred': isLoading }">
        <router-view/>
        <notifications position="top right"/>
    </div>
</template>

<script>
import { getRetailGeneralParams, getPermissions } from '@/components/controllers/LoginController.js'
import { startUp } from '@/components/controllers/StartUpController.js'
import { setAppColors } from '@/libs/Util'

export default {
    name: 'App',
    data () {
        return {
            isLoading: true
        }
    },
    async created () {
        startUp()
        await getPermissions()
    },
    async mounted () {
        await getRetailGeneralParams()
        setAppColors()
        this.isLoading = false
    }
}
</script>

<style lang="less">
@import '@fortawesome/fontawesome-free/css/all.css';
@import '@/assets/default/fonts/Gellix/stylesheet.less';
@import '@/assets/default/fonts/creditcard/stylesheet.less';

// @primaryColor: orange;

html, body{
  margin: 0;
  padding: 0;
  background-color: var(--backgroundColor);
}

#app {
    font-family: Gellix;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--backgroundColor);
    color: var(--textColor);
    // color: #2c3e50;
    font-size: 1.1rem;
    height: calc(100vh - 30px);
    width: calc(100vw - 30px);
    overflow: hidden;
    padding: 15px;
}

@media (min-aspect-ratio: 1/1) {
  #app {
    width: 50%;
    margin: auto;
  }
}

.vue-notification-group {
    margin: 0 !important;
}

.vue-notification-wrapper {
    margin: auto 0 auto auto !important;
}

.vue-notification-template {
    margin: 0 !important;
}

:root {
    // --primaryColor: #0098b7;
    --primaryColor: #222; //cucinare
    --primaryLight: #6e3636;
    --primaryDark: #000;
}
h1,h2,h3, button {
    font-weight: normal;
    font-size: 1.1rem;
    padding: 0;
    margin: 0;
}

select.default {
    width: 100%;
    border-radius: 5px;
    padding: 15px 10px;
    background: #E2E2E2;
    border: none;
}

.disabled-permission-button {
    pointer-events: none;
    opacity: 0.6;
}

.blurred {
  filter: blur(50px);
  pointer-events: none;
  opacity: 0.7;
}
</style>
